import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Play, Check } from 'lucide-react';

export const HeroSection = () => {
  const microBenefits = [
    'Bygget til live events',
    'Stabil drift i peak-perioder',
    'Softwareplatform – hardware via partnere',
  ];

  return (
    <section data-testid="hero-section" className="relative pt-32 pb-20 md:pt-40 md:pb-28 overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-20 right-0 w-[500px] h-[500px] bg-accent-blue/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-purple/4 rounded-full blur-3xl"></div>
      </div>

      <div className="container-custom">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            <div className="space-y-5">
              <h1 className="font-heading font-bold text-foreground leading-tight text-4xl sm:text-5xl lg:text-6xl">
                Driv jeres event fra ét samlet system
              </h1>
              <p className="text-lg md:text-xl text-body-text leading-relaxed max-w-xl">
                MUSEIQ hjælper festivaler, venues og events med at reducere køer, øge omsætningen og få overblik over driften.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                data-testid="hero-cta-primary"
                size="xl"
                className="cta-button-neutral group text-lg font-semibold py-4 px-8"
                onClick={() => {
                  const subject = encodeURIComponent("Anmodning om demo - MUSEIQ");
                  const body = encodeURIComponent("Hej MuseIQ\n\nJeg vil gerne booke en demo af jeres løsning.\n\nI må meget gerne kontakte mig for at aftale et tidspunkt.\n\nBedste hilsner\n[Navn]\n[Virksomhed]");
                  window.location.href = `mailto:Kasper@museiq.io?subject=${subject}&body=${body}`;
                }}
              >
                Book en demo
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </Button>
            </div>

            {/* Micro-benefits */}
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-6">
              {microBenefits.map((benefit, i) => (
                <div key={i} className="flex items-center gap-2 text-sm text-body-text">
                  <Check className="h-4 w-4 text-accent-blue flex-shrink-0" />
                  <span>{benefit}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-large">
              <img
                src="https://images.unsplash.com/photo-1685213400738-2841133e840d?w=800&q=80"
                alt="Festival publikum ved scene"
                className="w-full h-auto object-cover aspect-[4/3]"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
